(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 7353:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(2683);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Home": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2116);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6006);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2172);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4958);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);




/* eslint-disable react/iframe-missing-sandbox */ const Home = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
        className: "jsx-85dc8fe36608a1fe" + " " + "container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("title", {
                        className: "jsx-85dc8fe36608a1fe",
                        children: "The Egg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        content: "A page about life on earth",
                        name: "description",
                        className: "jsx-85dc8fe36608a1fe"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                id: "main",
                className: "jsx-85dc8fe36608a1fe",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("h1", {
                        className: "jsx-85dc8fe36608a1fe",
                        children: [
                            "Welcome to ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("a", {
                                href: "https://nextjs.org",
                                className: "jsx-85dc8fe36608a1fe",
                                children: "Overnext!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("p", {
                        className: "jsx-85dc8fe36608a1fe" + " " + "description",
                        children: [
                            "An overly opinionated starter for ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("code", {
                                className: "jsx-85dc8fe36608a1fe",
                                children: "next.js"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                        className: "jsx-85dc8fe36608a1fe" + " " + "py-20",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("h2", {
                                className: "jsx-85dc8fe36608a1fe" + " " + "text-center text-3xl text-gray-700 dark:text-gray-100",
                                children: "A short story"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("iframe", {
                                allowFullScreen: true,
                                allow: "autoplay; encrypted-media; picture-in-picture",
                                height: "315",
                                loading: "lazy",
                                sandbox: "allow-scripts allow-same-origin",
                                src: "https://www.youtube-nocookie.com/embed/h6fcK_fRYaI",
                                srcDoc: "<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%;}div{display:grid;place-items:center;}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:50px;text-align:center;font:28px/50px sans-serif;color:white; width: 13%;background-color: rgba( 0, 0, 0, 0.6 );border-radius:10px}span:hover{background-color: red}</style><a href=https://www.youtube-nocookie.com/embed/h6fcK_fRYaI?autoplay=1><img src=https://img.youtube.com/vi/h6fcK_fRYaI/hqdefault.jpg alt='Kurzgesagt: The Egg' /><div><span>►</span></div></a>",
                                title: "YouTube video player",
                                width: "560",
                                className: "jsx-85dc8fe36608a1fe"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("button", {
                        "data-cy": "test-button",
                        type: "button",
                        // eslint-disable-next-line react/jsx-no-bind
                        onClick: ()=>{
                            window.alert("With TypeScript and Jest") // eslint-disable-line no-alert
                            ;
                        },
                        className: "jsx-85dc8fe36608a1fe",
                        children: "Test Button"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("h2", {
                        className: "jsx-85dc8fe36608a1fe",
                        children: "Some further info"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                        className: "jsx-85dc8fe36608a1fe" + " " + "grid",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("a", {
                                href: "https://nextjs.org/docs",
                                className: "jsx-85dc8fe36608a1fe" + " " + "card",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("h3", {
                                        className: "jsx-85dc8fe36608a1fe",
                                        children: "Documentation →"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("p", {
                                        className: "jsx-85dc8fe36608a1fe",
                                        children: "Find in-depth information about Next.js features and API."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("a", {
                                href: "https://nextjs.org/docs/getting-started",
                                className: "jsx-85dc8fe36608a1fe" + " " + "card",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("h3", {
                                        className: "jsx-85dc8fe36608a1fe",
                                        children: "Learn →"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("p", {
                                        className: "jsx-85dc8fe36608a1fe",
                                        children: "Learn about Next.js in an interactive course with quizzes!"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                href: "/legal",
                                locale: "fr",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("a", {
                                    "data-cy": "fr-legal",
                                    className: "jsx-85dc8fe36608a1fe" + " " + "card",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("h3", {
                                            className: "jsx-85dc8fe36608a1fe",
                                            children: "Legal →"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("p", {
                                            className: "jsx-85dc8fe36608a1fe",
                                            children: "Discover and enjoy the depths of legal issues."
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("a", {
                                href: "https://vercel.com/import?filter=next.js",
                                className: "jsx-85dc8fe36608a1fe" + " " + "card",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("h3", {
                                        className: "jsx-85dc8fe36608a1fe",
                                        children: "Deploy →"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("p", {
                                        className: "jsx-85dc8fe36608a1fe",
                                        children: "Instantly deploy your Next.js site to a public URL with Vercel."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "a8b583f9fe0441d2",
                children: "button.jsx-85dc8fe36608a1fe{background:#0072ed}"
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "7a861ab4fafc3634",
                children: 'html,body{color:#000;background:#fff}[data-theme="dark"],[data-theme="dark"] body{color:#fff;background:#000}a{color:#0072ed}iframe{border:0}'
            })
        ]
    });
/* eslint-enable react/iframe-missing-sandbox */ /* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [888,774,179], function() { return __webpack_exec__(7353); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);